import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChatBubbleCluster = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 272 170",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_dddd_8741_3)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M79.9422 188.967C79.7081 188.751 79.456 188.535 79.2038 188.337C76.1421 185.779 72.5041 183.888 68.5239 182.862C66.3267 182.303 64.0395 181.997 61.6801 181.997H52.5491C49.3433 181.997 46.2817 181.457 43.4181 180.43C38.1051 178.557 33.5306 175.081 30.2888 170.579C29.7665 169.84 29.2623 169.084 28.812 168.291C27.9836 166.851 27.2632 165.32 26.7048 163.717C25.6963 160.871 25.138 157.792 25.138 154.586C25.138 151.38 25.6963 148.318 26.7048 145.455C29.4604 137.675 35.6198 131.497 43.4181 128.76C46.2817 127.751 49.3433 127.193 52.5491 127.193C55.7549 127.193 58.8166 127.751 61.6801 128.76C64.1475 129.624 66.4528 130.831 68.5239 132.344C73.0264 135.585 76.5023 140.142 78.3754 145.473C79.3839 148.336 79.9422 151.398 79.9422 154.604V188.985V188.967Z",
				fill: "#FF375B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M94.7998 46.004C94.9439 45.842 95.106 45.6618 95.2501 45.4818C97.0511 43.3206 98.3838 40.7631 99.1042 37.9716C99.5004 36.4228 99.7165 34.8199 99.7165 33.1449V26.7154C99.7165 24.4642 100.095 22.303 100.815 20.2859C102.13 16.5398 104.597 13.316 107.749 11.0468C108.271 10.6685 108.812 10.3264 109.352 10.0022C110.36 9.40785 111.441 8.92158 112.576 8.52536C114.593 7.82298 116.754 7.42676 119.005 7.42676C121.256 7.42676 123.418 7.82298 125.435 8.52536C130.91 10.4704 135.268 14.8108 137.195 20.2859C137.916 22.303 138.294 24.4642 138.294 26.7154C138.294 28.9666 137.898 31.1278 137.195 33.1449C136.583 34.8739 135.736 36.4948 134.674 37.9716C132.387 41.1414 129.181 43.5907 125.435 44.9054C123.418 45.6078 121.256 46.004 119.005 46.004H94.7998Z",
				fill: "#FFF3EB"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M94.7998 188.968C95.3221 188.499 95.8444 188.031 96.4027 187.599C103.012 182.106 110.847 177.999 119.401 175.802C124.12 174.578 129.073 173.929 134.17 173.929H153.854C160.752 173.929 167.38 172.741 173.539 170.561C185.012 166.509 194.845 159.017 201.833 149.328C202.968 147.743 204.03 146.104 205.021 144.393C206.822 141.277 208.352 137.999 209.559 134.541C211.738 128.4 212.927 121.754 212.927 114.857C212.927 107.959 211.738 101.331 209.559 95.1718C203.634 78.3865 190.325 65.0952 173.557 59.1699C167.398 56.9907 160.77 55.8021 153.872 55.8021C146.975 55.8021 140.347 56.9907 134.188 59.1699C128.875 61.043 123.904 63.6544 119.419 66.8782C109.73 73.866 102.22 83.6995 98.1857 95.1718C96.0065 101.331 94.8178 107.959 94.8178 114.857V188.95L94.7998 188.968Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M79.9425 111.975C79.5823 111.579 79.2221 111.165 78.8799 110.75C74.6476 105.672 71.5138 99.6564 69.8209 93.0827C68.8844 89.4627 68.3801 85.6626 68.3801 81.7365V66.6261C68.3801 61.3312 67.4796 56.2344 65.8047 51.5158C62.689 42.709 56.9438 35.1448 49.4877 29.7958C48.263 28.9133 47.0023 28.1029 45.7056 27.3465C43.3103 25.9597 40.7889 24.7891 38.1414 23.8526C33.4228 22.1776 28.326 21.2771 23.0311 21.2771C17.7362 21.2771 12.6393 22.1956 7.92074 23.8526C-4.95636 28.4091 -15.168 38.6207 -19.7245 51.4978C-21.3814 56.2524 -22.2999 61.3312 -22.2999 66.6261C-22.2999 71.9211 -21.3814 77.0179 -19.7065 81.7365C-18.2657 85.8067 -16.2666 89.6248 -13.7812 93.0827C-8.41427 100.521 -0.868103 106.284 7.93875 109.4C12.6754 111.075 17.7542 111.975 23.0491 111.975H79.9425Z",
				fill: "#FF9903"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_dddd_8741_3",
		x: -25.8967,
		y: .9526,
		width: 297.81,
		height: 226.158,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 2.8774,
				dy: 1.4387
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.23708 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.05 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_8741_3"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 10.0709,
				dy: 5.03546
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5.75481 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.04 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect1_dropShadow_8741_3",
				result: "effect2_dropShadow_8741_3"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 23.0192,
				dy: 11.5096
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 7.55318 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.03 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect2_dropShadow_8741_3",
				result: "effect3_dropShadow_8741_3"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 41.003,
				dy: 20.1418
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 8.99189 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.01 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect3_dropShadow_8741_3",
				result: "effect4_dropShadow_8741_3"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect4_dropShadow_8741_3",
				result: "shape"
			})
		]
	}) })]
});
export default SvgChatBubbleCluster;
